import { Directive, TemplateRef, inject, input } from '@angular/core';

/**
 * Markeert een `<ng-template>` als een **vaste** (niet-sluitbare) tab van een
 * {@link DockAreaComponent}. De host rendert per gemarkeerde template één
 * tab-knop met het opgegeven label en projecteert de template-inhoud in de
 * content-zone.
 *
 * Gebruik:
 * ```html
 * <dock-area>
 *   <ng-template dockFixedTab="Kanalen"> ...configurator... </ng-template>
 *   <ng-template dockFixedTab="Gates">   ...configurator... </ng-template>
 * </dock-area>
 * ```
 *
 * In tegenstelling tot een enkele `<ng-content>`-projectie laat dit een
 * **willekeurig aantal** vaste tabs toe — nodig voor de BAC-pagina waar zowel
 * de Kanalen- als Gates-configurator als aparte tab beschikbaar moeten zijn.
 */
@Directive({
  selector: '[dockFixedTab]',
  standalone: true,
})
export class DockFixedTabDirective {
  /** Label van de vaste tab-knop (mag vertaald zijn en wisselen). */
  readonly label = input.required<string>({ alias: 'dockFixedTab' });
  /**
   * Stabiele sleutel voor {@link DockAreaComponent.activateFixedTab}, los van
   * het (vertaalde) label. Zonder id volstaat het label als sleutel.
   */
  readonly id = input<string | undefined>(undefined, { alias: 'dockFixedTabId' });
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
